import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { runFireworks } from "../lib/utils";
import { keyframes } from "styled-components";
import { renderResult } from "../apiCalls";
import CopyrightIcon from "@material-ui/icons/Copyright";

const Container = styled.div`
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
`;
const H1 = styled.h1`
  font-size: 32px;
  text-align: center;
  @media only screen and (max-width: 767px) {
    font-size: 18px;
  }
`;
const Shake = keyframes`

0% {
    transform: translate(1px, 1px) rotate(0deg);
  }
  10% {
    transform: translate(-1px, -2px) rotate(-1deg);
  }
  20% {
    transform: translate(-3px, 0px) rotate(1deg);
  }
  30% {
    transform: translate(3px, 2px) rotate(0deg);
  }
  40% {
    transform: translate(1px, -1px) rotate(1deg);
  }
  50% {
    transform: translate(-1px, 2px) rotate(-1deg);
  }
  60% {
    transform: translate(-3px, 1px) rotate(0deg);
  }
  70% {
    transform: translate(3px, 1px) rotate(-1deg);
  }
  80% {
    transform: translate(-1px, -1px) rotate(1deg);
  }
  90% {
    transform: translate(1px, 2px) rotate(0deg);
  }
  100% {
    transform: translate(1px, -2px) rotate(-1deg);
  }


`;

const Button = styled.button`
  width: 70%;
  height: 30px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 18px;
  font-weight: 500;
  background-color: #31daaf;
  &:hover {
    animation: ${Shake} 0.5s;
    animation-iteration-count: 1;
  }
  &:disabled {
    animation-play-state: paused;
    cursor: not-allowed;
  }
`;

const Input = styled.input`
  width: 100%;
  display: flex;
  justify-content: center;
  height: 30px;
  border: none;
  border-radius: 5px;
  text-align: center;
  font-size: 22px;
  &:focus {
    outline: none;
  }
  @media only screen and (max-width: 380px) {
    width: 200px;
  }
`;

const DataContainer = styled.form`
  width: 350px;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  top: 30px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  justify-content: space-around;
  @media only screen and (max-width: 380px) {
    width: 250px;
    height: 170px;
    top: 18px;
  }
`;

const Text = styled.p`
  text-align: center;
`;
const Footer = styled.div`
  position: fixed;
  left: 0;
  bottom: 20px;
  width: 100%;
  color: white;
  text-align: center;
  justify-content: center;
  display: flex;

  @media only screen and (max-width: 767px) {
    width: 100%;
    flex-direction: column;
  }
`;

const Span = styled.span`
  justify-content: center;
  align-items: center;
  display: flex;
`;
const Link = styled.a`
  color: crimson;
  font-weight: 800;
  font-size: 16px;
`;

const Error = styled.h1`
  color: #1ef61e;
  font-size: 12px;
`;

const Congrat = ({ user, idUser }) => {
  const [email, setEmail] = useState("");
  const [validation, setValidation] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  useEffect(() => {
    runFireworks();
  }, []);

  useEffect(() => {
    if (email.length < 2) {
      setIsButtonDisabled(true);
    } else {
      setIsButtonDisabled(false);
    }
  }, [email]);

  const handleClick = (e) => {
    e.preventDefault();
    renderResult({ id: idUser, email: email });
    setValidation(true);
  };

  return (
    <>
      <Container>
        <H1>
          Congratulations {user?.savedUser?.username}! ✨🎉🥇 You're a
          Millionaire
        </H1>
        <DataContainer>
          <Text>
            We are proud of you 💥💎🤗, If you want to live another millionaire
            challenge 🤑, Please enter your email to contact you soon !!
          </Text>
          <Input
            placeholder="Enter your Email"
            onChange={(e) => setEmail(e.target.value)}
            type="email"
          />
          <Button onClick={handleClick} disabled={isButtonDisabled}>
            Send
          </Button>
          {validation ? (
            <Error>
              Your email has been sent successfully ! Thank you 😊😉
            </Error>
          ) : null}
        </DataContainer>
      </Container>
      <Footer>
        Created with love by &nbsp;
        <Link href="https://www.linkedin.com/in/mahmoud-ayed-111329207">
          &#9825; Mahmoud &#9825;
        </Link>
        <Span>
          &nbsp; <CopyrightIcon />
          2022 All rights reserved.
        </Span>
      </Footer>
    </>
  );
};

export default Congrat;
